import * as React from "react";
import { cn } from "@/lib/utils";

export const Tag = React.forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>(
  ({ className, ...rest }, ref) => (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center font-mono text-[10px] uppercase tracking-wider",
        "rounded-[3px] bg-bg-muted-rd px-1.5 py-0.5 text-text-tertiary",
        className
      )}
      {...rest}
    />
  )
);
Tag.displayName = "Tag";
